import { render } from "./B2bTableCmrDraft.vue?vue&type=template&id=06576a9e&scoped=true&lang=pug"
import script from "./B2bTableCmrDraft.vue?vue&type=script&lang=js"
export * from "./B2bTableCmrDraft.vue?vue&type=script&lang=js"

import "./B2bTableCmrDraft.vue?vue&type=style&index=0&id=06576a9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06576a9e"]])

export default __exports__